// extracted by mini-css-extract-plugin
export default {"tableWrapper":"D4ZGOXm93JptS51dmUQM"};